import React, { useRef } from 'react';
import { useInView, motion } from 'framer-motion';
import { slideUp, opacity } from './anim';
import styles from './TextReveal.module.css';

export default function TextReveal({ phrase, subtext, children }) {
  const container = useRef(null);
  const isInView = useInView(container, { once: false, margin: "-10%" });

  return (
    <div ref={container} className={styles.body}>
      <p className={styles.phrase}>
        {phrase.split(" ").map((word, index) => (
          <span key={index} className={styles.mask}>
            <motion.span
              variants={slideUp}
              custom={index}
              animate={isInView ? "open" : "closed"}
            >
              {word}
            </motion.span>
          </span>
        ))}
      </p>
      {subtext && (
        <motion.p
          className={styles.sub}
          variants={opacity}
          animate={isInView ? "open" : "closed"}
        >
          {subtext.split('\n').map((line, i, arr) => (
            <React.Fragment key={i}>
              {line}
              {i < arr.length - 1 && <br />}
            </React.Fragment>
          ))}
        </motion.p>
      )}
      {children}
    </div>
  );
}
